export default __webpack_public_path__ + "assets/images/8c5355a5f6cd5f42a2a165cbe956e0b8.jpg";